import type { DomainManifest } from 'modules/core/lib/manifests/types'

import { AiReportsAction } from 'modules/ai_reports/lib/useCreateAnalyticsReportActionResolver'
import { CreateSurveyAction } from 'modules/forms/lib/oneHandlers/create-survey'

import { sidebarManifest } from './sidebar'

export const manifest = {
  sidebar: (navigation) => ({
    items: sidebarManifest(navigation),
  }),
  one: {
    createActions: {
      analyticsReport: AiReportsAction,
      createSurvey: CreateSurveyAction,
    },
  },
} as const satisfies DomainManifest
